import { Component, OnInit, Input } from '@angular/core';
import { BaseFormComponent } from '../../base-form.component';

@Component({
  moduleId: module.id,
  selector: 'basic-label',
  templateUrl: './basic-label.component.html',
})
export class BasicLabelComponent extends BaseFormComponent implements OnInit {
  @Input() displayText: string;
  @Input() inputClass: string;
  @Input() componentId: string;

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  updateFromModel() {}
}
